import * as React from "react";
const Windows10Logo = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={18}
    height={18}
    fill="none"
    {...props}
  >
    <path
      fill="#FFFEFF"
      d="m.001 2.479 7.377-1.016V8.59H0l.001-6.111Zm0 13.042 7.377 1.017v-7.04H0l.001 6.023Zm8.188 1.125L18.001 18V9.498H8.189v7.148Zm0-15.292V8.59h9.812V0L8.189 1.354Z"
    />
  </svg>
);
export default Windows10Logo;
